import React, { useEffect } from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import SingleNews from '../components/news-events/single-news'

import useScreen from '../hooks/use-screen'

const SingleNewsPage = ({ pageContext }) => {
  const {
    lang,
    pageData,
    sitePrefix,
    siteTitle = 'DURO TIRE',
    navRoutes,
  } = pageContext

  const screen = useScreen()

  const aside = {
    cat: 'about',
    menu: navRoutes.filter(d => d.slug === 'about')[0].subMenu,
    sitePrefix,
  }

  return (
    <Layout
      aside={aside}
      {...pageContext}
    >
      <SEO title={siteTitle} lang={lang} />
      <SingleNews pageData={pageData} sitePrefix={sitePrefix} />
    </Layout>
  )
}

export default SingleNewsPage
